// services/CitySponsorService.js

import { buildFormData } from "@/utils/commonUtils";
import httpService from "./httpService";
import { assertRequired, getWithQuery } from "@/services/utils/requestHelpers";

const headers = { "Content-Type": "multipart/form-data" };

const WalkerService = {
    getMapAll: async (props) => {
        return await getWithQuery(httpService, "map/walkers", props);
    },
    getAll: async (props) => {
        return await getWithQuery(httpService, "walker", props);
    },
    getId: async (id) => {
        assertRequired(id, "ID is required");
        return await httpService.get(`walkers/${id}`);
    },
    getByIP: async (ip_address) => {
        assertRequired(ip_address, "IP address is required");
        return await httpService.get(`walkers/by-ip/${ip_address}`);
    },
    getByIPName: async (ip_address,name) => {
        assertRequired(ip_address, "IP address is required");
        assertRequired(name, "Name is required");
        return await httpService.get(`walkers/${ip_address}/${name}`);
    },
    create: async (payload) => {
        const formData = buildFormData(payload);
        return await httpService.post("walker/create", formData, { headers });
    },
    update: async (payload) => {
        const { id } = payload || {};
        assertRequired(id, "Walker ID is required for update");
        const formData = buildFormData({ _method: "PUT", ...payload });
        return await httpService.post(`walkers/${id}`, formData, { headers });
    },
    delete: async (id) => {
        assertRequired(id, "Walker ID is required for deletion");
        return await httpService.delete(`walker/${id}`);
    },
};

export default WalkerService;
